import React from "react";

import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";

import { EditorialHeaderSerializer } from "web/types/serializers";
import { getDateText } from "./dates";

export function Header({
    title,
    authors,
    published_at: publishedAt,
    updated_at: updatedAt,
}: EditorialHeaderSerializer): React.ReactElement {
    const dateText = getDateText(publishedAt, updatedAt);

    return (
        <VStack spacing="lg">
            <Heading
                as="h1"
                textStyle={{ sm: "title-l", md: "large-title-2-v2" }}
                upperCase
                wordBreak
            >
                {title}
            </Heading>
            <Text textStyle="caption-3" upperCase>
                {dateText}
            </Text>
            {authors && (
                <Text textStyle="caption-3" upperCase>
                    {`Authored by ${authors}`}
                </Text>
            )}
        </VStack>
    );
}
